import { ThumbnailBtn as e, ThumbnailImg as t, ThumbnailScroller as n, ThumbnailStripWrapper as r } from "../styles.mjs";
import { useEffect as i, useRef as a } from "react";
import { jsx as o } from "react/jsx-runtime";
//#region src/components/FullscreenGallery/components/GalleryThumbnailStrip.tsx
var s = ({ images: s, currentIndex: c, onSelect: l, altPrefix: u }) => {
	let d = a([]);
	return i(() => {
		let e = d.current[c];
		e && e.scrollIntoView({
			behavior: "smooth",
			inline: "center",
			block: "nearest"
		});
	}, [c]), /* @__PURE__ */ o(r, { children: /* @__PURE__ */ o(n, { children: s.map((n, r) => /* @__PURE__ */ o(e, {
		ref: (e) => {
			d.current[r] = e;
		},
		$active: r === c,
		onClick: () => l(r),
		"aria-label": `${u} ${r + 1}`,
		children: /* @__PURE__ */ o(t, {
			src: n,
			alt: `${u} ${r + 1}`,
			draggable: !1
		})
	}, r)) }) });
};
//#endregion
export { s as GalleryThumbnailStrip };
